module.exports = "<!-- * PAGES * -->\n<!--<ddw-navbar></ddw-navbar>-->\n<router-outlet></router-outlet>\n<ddw-footer></ddw-footer>"